import ConfirmModal from '@components/modal/ConfirmModal';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { Submission } from 'src/types/shared/Assessments';
import useDeleteUserApplication from './hooks/useDeleteUserApplication';

const DeleteUserModal: React.FC<DeleteUserProps> = ({
    application,
    setUserApplicationToDelete,
}) => {
    const { handleSubmit, isPosting, error, postSuccess, prevSuccess } = useDeleteUserApplication(
        application,
    );

    useEffect(() => {
        if (postSuccess && !prevSuccess) {
            setUserApplicationToDelete(null);
        }
    }, [postSuccess, prevSuccess, setUserApplicationToDelete]);

    return (
        <ConfirmModal
            title="Delete user application"
            description={`Are you sure you want to delete this application for '${application.challengeName}'?`}
            closeModal={() => setUserApplicationToDelete(null)}
            handleSubmit={handleSubmit}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DeleteUserProps {
    application: Submission;
    setUserApplicationToDelete: Dispatch<SetStateAction<number | null>>;
}
export default DeleteUserModal;
